window.addEventListener("DOMContentLoaded", function() {
    const burgerSticky = document.getElementById('navbar-sticky');
    document.getElementById('navbar-burger').addEventListener('click', function () {
        burgerSticky.classList.toggle('hidden');
    });
});
